import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LogSeverity } from '../../synchronization.model';
import { QueueLogEntryDto } from '../queue-request.model';
import { ExpandableMessageComponent } from '../expandable-message/expandable-message.component';

/**
 * One log line.
 *
 * The severity class lands on the host so the left-edge bookmark works without a wrapper element,
 * and `variant` decides the indent and whether the emitting service is shown — a chunk-level line
 * never needs it, because the chunk it sits under already says where it came from.
 */
@Component({
    selector: 'app-queue-log-row',
    templateUrl: './queue-log-row.component.html',
    styleUrl: './queue-log-row.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DatePipe, ExpandableMessageComponent],
    host: {
        '[class]': 'severityClass()',
        '[class.executor-log-row]': "variant() === 'executor'",
        '[class.request-log-row]': "variant() === 'request'"
    }
})
export class QueueLogRowComponent {
    readonly entry = input.required<QueueLogEntryDto>();
    readonly variant = input<'request' | 'executor'>('request');

    protected readonly severityClass = computed(() => {
        switch (this.entry().severity) {
            case LogSeverity.Error:
            case LogSeverity.Critical:
                return 'log-row-error';
            case LogSeverity.Warning:
                return 'log-row-warning';
            default:
                return 'log-row-info';
        }
    });
}
